import { FC, useMemo } from 'react';
import DesktopHeaderConstructor from './DesktopHeaderConstructor';
import MobileHeaderConstructor from './MobileHeaderConstructor';
import TabletHeaderConstructor from './TabletHeaderConstructor';

export const HeaderConstructor: FC<{ type: 'desktop' | 'mobile' | 'tablet' }> = ({ type }) => {
  const HeaderComponent = useMemo(() => {
    switch (type) {
      case 'desktop':
        return DesktopHeaderConstructor;
      case 'mobile':
        return MobileHeaderConstructor;
      case 'tablet':
        return TabletHeaderConstructor;
    }
  }, [type]);

  return <HeaderComponent />;
};
